import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as seisan_follow_api from '../Api/seisan_follow_api';
import * as Monthly_Money_api from '../Api/MonthlyMoneyApi';



///types
const moment = require('moment')

export interface State {

    monthly_money_list: any;
    monthly_money_search_list: any;
    monthly_money_search: any;


}
const initialState: State = {

    monthly_money_list: [],
    monthly_money_search_list: [],
    monthly_money_search: { building_name: "", name: "", user_id: 0, flg: 0 },


}



///action 
const actionCreator = actionCreatorFactory();


export const get_monthly_money_list = actionCreator('GET_MONTHLY_MONEY_LIST');
export const change_monthly_money_list = actionCreator("CHANGE_MONTHLY_MONEY_LIST");


export const change_monthly_money_search_list = actionCreator<any>("CHANGE_MONTHLY_MONEY_SEARCH_LIST");
export const change_monthly_money_search = actionCreator<any>("CHANGE_MONTHLY_MONEY_SEARCH");

export const set_monthly_money_search_list = actionCreator("SET_MONTHLY_MONEY_SEARCH_LIST");

export const monthly_update = actionCreator("MONTHRY_UPDATE");

export const monthly_remarks = actionCreator("MONTHRY_REMARKS");



export const monthlyMoneyReducer = reducerWithInitialState(initialState)
    .case(change_monthly_money_list, (state, payload) => ({ ...state, monthly_money_list: payload }))

    .case(change_monthly_money_search_list, (state, payload) => ({ ...state, monthly_money_search_list: payload }))
    .case(change_monthly_money_search, (state, payload) => ({ ...state, monthly_money_search: payload }))





// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const monthlyMoneySaga = [

    takeEvery('GET_MONTHLY_MONEY_LIST', handle_get_monthly_money_list),

    takeEvery('SET_MONTHLY_MONEY_SEARCH_LIST', handle_set_monthly_money_search_list),

    takeEvery('MONTHRY_UPDATE', handle_monthly_update),

];



function* handle_monthly_update(action: any) :any{

    const { payload, error } = yield call(Monthly_Money_api.update, action.payload);

    const state = yield select();
    let monthly_money_list = state.MonthlyMoney.monthly_money_list
    console.log(action.payload)
    if (payload && !error) {
        console.log(payload)

        // 一覧の情報更新
        monthly_money_list = monthly_money_list.map(function (value: any) {
            if (value.id === action.payload.id) {
                if(action.payload.is_installment_payment == 1){//分割請求
                    console.log("分割請求")
                    if(value.mn_installment_payment_id === action.payload.mn_installment_payment_id){
                        if(action.payload.type == 2){
                            value.payment_date = moment(payload.payment_date).format("YYYY/MM/DD")
                        }else{
                            value.contract_remarks = payload.contract_remarks
                        }
                    }

                } else if(action.payload.mn_additional_payment_id > 0){//追加請求
                    console.log("追加請求")
                    if(value.mn_additional_payment_id === action.payload.mn_additional_payment_id){
                        if(action.payload.type == 2){
                            value.payment_date = moment(payload.payment_date).format("YYYY/MM/DD")
                        }else{
                            value.contract_remarks = payload.contract_remarks
                        }
                    }

                }else{//通常

                    if(value.mn_installment_payment_id === undefined && value.mn_additional_payment_id === undefined){
                        if(action.payload.type == 2){
                            value.payment_date = moment(payload.payment_date).format("YYYY/MM/DD")
                        }else{
                            value.contract_remarks = payload.contract_remarks
                        }
                    }
                }
                
            }
            return value
        })

        // 情報更新
        yield put(change_monthly_money_list(monthly_money_list));
        yield put(set_monthly_money_search_list())

    } else {
    }
}


function* handle_get_monthly_money_list(action: any) {

    const { payload, error } = yield call(Monthly_Money_api.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {


        yield put(change_monthly_money_list(payload))


        yield put(set_monthly_money_search_list())


    } else {
        alert(error)

    }



}


function* handle_set_monthly_money_search_list(action: any) : any {

    const state = yield select();



    let monthly_money_list = state.MonthlyMoney.monthly_money_list
    let monthly_money_search = state.MonthlyMoney.monthly_money_search

    console.log(monthly_money_search.building_name);

    if (monthly_money_search.building_name) {
        monthly_money_list = monthly_money_list.filter((a: any) => kanaToHira(a.building_name).indexOf(kanaToHira(monthly_money_search.building_name)) !== -1 || kanaToHira(a.building_name).indexOf(kanaToHira(monthly_money_search.building_name)) !== -1)

    }
    if (monthly_money_search.contractor_name1) {

        monthly_money_list = monthly_money_list.filter((a: any) => kanaToHira(a.contractor_name1).indexOf(kanaToHira(monthly_money_search.contractor_name1)) !== -1 || kanaToHira(a.contractor_name1).indexOf(kanaToHira(monthly_money_search.contractor_name1)) !== -1)

    }
    function kanaToHira(str: string) {
        return str.replace(/[\u30a1-\u30f6]/g, function (match) {
            var chr = match.charCodeAt(0) - 0x60;
            return String.fromCharCode(chr);
        });
    }


    let monthly_money_search_list: any = []
    monthly_money_list.map(function (value: any) {



        monthly_money_search_list.push(value)


    })
    yield put(change_monthly_money_search_list(monthly_money_search_list))
}
